import { render, staticRenderFns } from "./moderate-form.vue?vue&type=template&id=e5e59fd6&lang=pug&"
import script from "./moderate-form.vue?vue&type=script&lang=js&"
export * from "./moderate-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports